exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".countdown-widget {\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/countdownWidget/countdown-widget.component.scss
// module id = ../../../../../app/shared/components/countdownWidget/countdown-widget.component.scss
// module chunks = main